export const spacingRem = (px: number): string => `${px / 16}rem`;
